import React from 'react';
import { ListItemColumn } from '@pearsontechnology/aero-components';

import {
  PlaceholderIcon,
  PlaceholderText,
  ListItem,
} from './styles';

const PlaceholderRow = () => (
  <ListItem>
    <ListItemColumn colWidth="60%">
      <PlaceholderIcon />
      <PlaceholderText height={10} maxWidth={200} />
    </ListItemColumn>
    <ListItemColumn colWidth="18%">
      <PlaceholderText height={10} maxWidth={100} />
    </ListItemColumn>
    <ListItemColumn colWidth="18%">
      <PlaceholderText height={13} maxWidth={100} />
    </ListItemColumn>
  </ListItem>
);

export default PlaceholderRow;
